import React, { useEffect, useState } from 'react';
import StAddNew from './DSeries/StAddNew';
import { Button, Col, Dropdown, Form, Modal, Row, Tooltip, message } from 'antd';
import InputIdentify from './InputCreater/InputCreater';
import { useSelector } from 'react-redux';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import { CodeOutlined, DeleteOutlined, EditOutlined, EllipsisOutlined } from '@ant-design/icons';
import ZenFormInput from './InputCreater/ZenFormInput';
import JsonEditor from 'react-json-editor-ui';
import FooterButtons from '../components/STORM/FooterButtons';

const QueryBuilder = ({
    setPageHeader
}) => {
    const urlCode = useSelector(state => state.urlCode);
    const LocalDict = [];
    const [modalTitle, setModalTitle] = useState('');
    const [pageLoading, setPageLoading] = useState(false);
    const nonEditableControl = ['TypSubTyp', 'TypSubTypDynamic', 'dropDownTree', 'serialBlock', 'gilDropdown', 'multiLevelDropdown'];

    const [dictForm] = Form.useForm();
    const [dictFormVal, setDictFormVal] = useState();
    const [previewForm] = Form.useForm();
    const [smodalForm] = Form.useForm();
    const [controlJsonData, setControlJsonData] = useState({})
    const [jsonModalData, setJSONModalData] = useState({
        open: false,
        typ: '',
        data: null
    })
    const [elementLoading, setElementLoading] = useState(true);
    const [form] = Form.useForm();
    const [smodalLoading, setSmodalLoading] = useState(false);

    const [modalElements, setModalElements] = useState();
    const [modalData, setModalData] = useState({
        open: false,
        typ: '',
        data: null
    });
    const [pageConfigData, setPageConfigData] = useState();
    const zenFooterButtons = [
        {
            typ: 'radio',
            label: 'Validate Fields',
            default: 'true',
            data_index: 'buttonProp-validateFields',
            visible: true,
            colSize: 24,
            labelColSize: 10,
            data: {
                true: 'Yes',
                false: 'No'
            }
        },
        {
            typ: 'gilDropdown',
            colSize: 24,
            labelColSize: 10,
            default: 'false',
            data_index: 'buttonProp-hover',
            visible: true,
            label: 'Hover',
            data: {
                true: 'Yes',
                false: 'No'
            },
            children: {
                true: [
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Label On Hover',
                        data_index: 'hoverProp-label',
                        required: true,
                        default: 'Button'
                    },
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Tooltip On Hover',
                        data_index: 'hoverProp-toolTip',
                        required: true,
                        default: 'Button Hover'
                    },
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Background Color On Hover',
                        data_index: 'hoverProp-backgroundColor',
                        required: true,
                        default: 'green'
                    },
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Font Color On Hover',
                        data_index: 'hoverProp-color',
                        required: true,
                        default: '#ffffff'
                    },
                    {
                        typ: 'intControl',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Font Size On Hover',
                        data_index: 'hoverProp-fontSize',
                        required: true,
                        default: 13
                    },
                ]
            }
        },
        {
            typ: 'gilDropdown',
            default: 'false',
            colSize: 24,
            labelColSize: 10,
            visible: true,
            data_index: 'buttonProp-confirmationPopUp',
            label: 'Confirmation Popup',
            data: {
                true: 'Yes',
                false: 'No'
            },
            children: {
                true: [
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Text',
                        required: true,
                        data_index: 'confirmationPopUpProp-text',
                        default: 'Are you sure you want to submit this data?'
                    },
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'OK Button Label',
                        data_index: 'confirmationPopUpProp-okButtonLabel',
                        default: 'Yes'
                    },
                    {
                        typ: 'textBox',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Cancel Button Label',
                        data_index: 'confirmationPopUpProp-cancelButtonLabel',
                        default: 'Cancel'
                    },
                ]
            }
        },
        {
            typ: 'gilDropdown',
            colSize: 24,
            labelColSize: 10,
            default: 'false',
            data_index: 'buttonProp-submitFormData',
            visible: true,
            label: 'Submit Form Data',
            data: {
                true: 'Yes',
                false: 'No'
            },
            children: {
                true: [
                    {
                        typ: 'dropDown',
                        labelColSize: 10,
                        colSize: 24,
                        data_index: 'submitFormDataProp-method',
                        default: 'POST',
                        source: 'data',
                        p_data_index: 'submitFormDataProp-p_method',
                        data: {
                            "POST": "POST",
                            "PATCH": "PATCH",
                        },
                        label: 'Method',
                        required: true
                    },
                    {
                        typ: 'textBox',
                        label: 'API URL',
                        labelColSize: 10,
                        colSize: 24,
                        data_index: 'submitFormDataProp-url',
                        default: '/textapi',
                        required: 'true'
                    },
                    {
                        typ: 'textBox',
                        label: 'Params',
                        labelColSize: 10,
                        colSize: 24,
                        data_index: 'submitFormDataProp-params',
                        default: '{"a": "b"}',
                        required: 'true'
                    },
                ]
            }
        },
        {
            typ: 'gilDropdown',
            default: 'false',
            colSize: 24,
            labelColSize: 10,
            label: 'Post Submit Action',
            data_index: 'buttonProp-postSubmitAction',
            visible: true,
            data: {
                true: 'Yes',
                false: 'No'
            },
            children: {
                true: [
                    {
                        typ: 'dropDown',
                        labelColSize: 10,
                        colSize: 24,
                        label: 'Action',
                        required: true,
                        source: 'data',
                        default: 'postSubmitActionProp-clearForm',
                        p_data_index: 'postSubmitActionProp-p_action',
                        data_index: 'postSubmitActionProp-action',
                        data: {
                            'clearForm': 'Clear Form',
                            'blankPage': 'Blank Page',
                            'reloadStorm': 'Reload Storm',
                            'newTab': 'New Tab',
                            'reloadPage': 'Reload Page',
                            'refresh Stable': 'Refresh Stable',
                        }
                    },
                    {
                        labelColSize: 10,
                        colSize: 24,
                        typ: 'textBox',
                        data_index: 'postSubmitActionProp-route',
                        default: '/dashboard',
                        required: false,
                        label: 'Route'
                    }
                ]
            }
        },
        {
            typ: 'gilDropdown',
            default: 'false',
            data_index: 'buttonProp-popupModal',
            visible: true,
            label: 'Poppupmodal',
            colSize: 24,
            labelColSpan: 8,
            data: {
                true: 'Yes',
                false: 'No'
            },
            children: {
                true: [
                    {
                        typ: 'dropDown',
                        source: 'dynamic',
                        visible: true,
                        colSize: 24,
                        labelColSpan: 8,
                        label: 'Smodal',
                        isSearchable: true,
                        sourceParams: {
                            typ: 'smodal'
                        }
                    }
                ]
            }

        }
    ];
    const footerButtonElements = [
        {
            required: true,
            typ: 'textBox',
            visible: true,
            label: 'Label',
            data_index: 'label'
        },
        {
            required: true,
            typ: 'dropDown',
            visible: true,
            source: 'data',
            data: {
                primary: 'Primary',
                danger: 'Danger'
            },
            label: 'Type',
            data_index: 'type',
            p_data_index: 'p_type'
        },
        {
            required: true,
            typ: 'radio',
            label: 'Enable',
            default: true,
            visible: true,
            data_index: 'enable'
        },
        {
            required: true,
            typ: 'radio',
            visible: true,
            label: 'Visible',
            default: true,
            data_index: 'visible'
        }
    ]
    const [selectedControls, setSelectedControls] = useState([]);
    const [footerBtnModal, setFooterBtnModal] = useState({
        open: false,
        data: null,
        typ: ''
    });

    useEffect(() => {
        setPageHeader('Query Builder')
        if (modalTitle) {
            if (modalData.typ === 'add-control') {
                smodalForm.setFieldsValue({ ['indx']: pageConfigData?.config?.modalElements?.length || 0 })
            }
        }
    }, [modalTitle]);


    const closeModal = () => {
        setElementLoading(true);
        setModalTitle(undefined);
        setTimeout(() => {
            setModalData({
                open: false,
                data: null,
                typ: ''
            })
        }, 20);
    };

    const closeFooterBtnModal = () => {
        setElementLoading(true);
        setModalTitle(undefined);
        form.resetFields();
        setTimeout(() => {
            setFooterBtnModal({
                open: false,
                data: null,
                typ: ''
            })
        }, 20);
    };

    const closeJSONModal = () => {
        setElementLoading(true);
        setModalTitle(undefined);
        setTimeout(() => {
            setControlJsonData({});
            setJSONModalData({
                open: false,
                data: null
            });
        }, 20);
    }

    const openJSONModal = (data) => {

        // liracrypt.get('/smodal/zenform', {...data})
        //     .then(response => {
        //         console.log(response);
        //         let __data = {};
        //         response.data.config.modalElements.map(x => {
        //             __data[x.data_index] = x.default
        //         })
        //         setControlJsonData(data);
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     })
        let controlData = { ...data };
        delete controlData.dictName;
        delete controlData.zenPreviewListIndex;
        // delete controlData.typ;
        setElementLoading(false);
        setControlJsonData(controlData);
        setTimeout(() => {
            setJSONModalData({
                open: true,
                data: data
            });
        }, 500)
        // liracrypt.get('/smodal/zenform', data)
        //     .then(response => {
        //         console.log(response.data.config.modalElements);
        //         console.log(data);
        //         setControlJsonData(data);
        //         setTimeout(() => {
        //             setJSONModalData({
        //                 open: true,
        //                 data: response.data.data
        //             });
        //         }, 1000)

        //     }).catch(err => {
        //         ApiErrorComp();
        //         console.log(err);
        //     })
    }

    const downloadJson = () => {
        liracrypt.get('/pageconfig/download', { ...dictForm.getFieldsValue(), dictName: pageConfigData?.config?.dictName, pageconfigId: pageConfigData?.config?.pageconfigId }).then(({ data }) => {
            if (data.isSuccess) {
                window.open(
                    `${process.env.REACT_APP_API_ENDPOINT}/fetchfilesingleattachmentzenform?filePath=${data.data.filePath}&fileName=${data.data.fileName}&token=${localStorage.getItem("token")}&urlCode=${urlCode}`,
                    '_blank'
                )
            } else {
                message.error(data.message);
            }
        })
    }

    const openSmodal = ({ typ, data }) => {
        setElementLoading(false);
        setModalData({
            open: true,
            typ,
            data
        })
    };
    const openFooterModal = ({ typ, data }) => {
        setElementLoading(false);
        setModalElements(footerButtonElements);
        setFooterBtnModal({
            open: true,
            typ,
            data
        })
    };

    const saveQuery = ({ elements, footerBtns }) => {
        let configData = { ...pageConfigData };
        if (elements) {
            configData.config.modalElements = elements;
        }
        if (footerBtns) {
            configData.config.footerButtons = footerBtns;
        };
        configData = { ...configData, ...dictForm.getFieldsValue() }
        liracrypt.patch('/zenformbuilder', configData)
            .then(({ data }) => {
                if (data.isSuccess) {
                    //     message.success('Saved Successfully');
                    closeModal();
                    closeJSONModal();
                    closeFooterBtnModal();
                    dictForm.submit();
                } else {
                    message.error('Error');
                }
            })
            .catch(err => {
                console.log(err);
                ApiErrorComp()
            })
    }

    const saveFooterBtn = (values) => {
        delete values.p_type;
        if (footerBtnModal.typ === 'edit-footer-btn') {
            let footerBtns = { ...pageConfigData?.config?.footerButtons };
            let editedBtn = {};
            let dictKeyList = [];
            Object.keys(values).forEach(x => {
                let key = x.split('-')[0];
                if (!dictKeyList.includes(key)) {
                    dictKeyList.push(key);
                }
            });
            dictKeyList.forEach(x => {
                if (x === 'buttonProp') {
                    editedBtn[x] = footerBtns[footerBtnModal.data].buttonProp
                }
                Object.keys(values).forEach(y => {
                    if (values[y] === 'true') {
                        values[y] = true;
                    }
                    if (values[y] === 'false') {
                        values[y] = false;
                    }
                    let key = y.split('-')[1];
                    if (y.includes(x)) {
                        editedBtn[x] = {
                            ...editedBtn[x],
                            [key]: values[y]
                        }
                    }
                })
            });
            if (editedBtn.hoverProp) {
                editedBtn.hoverProp.css = {
                    backgroundColor: editedBtn.hoverProp?.backgroundColor,
                    fontSize: editedBtn.hoverProp?.fontSize,
                    color: editedBtn.hoverProp?.color
                };
                delete editedBtn.hoverProp?.backgroundColor;
                delete editedBtn.hoverProp?.color;
                delete editedBtn.hoverProp?.fontSize;
            }
            delete editedBtn.p_submitFormDataProp;
            footerBtns[footerBtnModal.data] = editedBtn;
            saveQuery({ footerBtns: footerBtns })
            return;

        }
        let footerBtns = { ...pageConfigData?.config?.footerButtons };
        let footerBtnName = Object.keys(footerBtns);
        if (footerBtnName.length) {
            let lastBtn = footerBtnName[footerBtnName.length - 1]
            lastBtn = parseInt(lastBtn.split('button')[1]) + 1;
            footerBtns[`button${lastBtn}`] = {
                buttonProp:
                    values
            }
        } else {
            footerBtns['button1'] = {
                buttonProp:
                    values
            }
        }
        return saveQuery({ footerBtns: footerBtns });
    }


    const addControl = (values) => {
        console.log(values);
        let specificIndx = '';
        if (values.indx) {
            specificIndx = parseInt(values.indx);
        }
        let elementLists = [...selectedControls];
        if (values.typ === 'dropDown') {
            values.source = 'data';
        }
        if (values.typ === 'serialBlock') {
            values.data = [
                {
                    "blockStyle": {
                        "minWidth": "15%",
                        "padding": 20,
                        "marginRight": 2,
                        "cursor": "pointer",
                        "background": "rgb(59, 60, 81)"
                    },
                    "icon": {
                        "img": "https://pixsector.com/cache/517d8be6/av5c8336583e291842624.png",
                        "style": {
                            "width": "50px",
                            "height": "auto"
                        }
                    },
                    "title": {
                        "text": "Sunday",
                        "style": {
                            "textAlign": "center",
                            "color": "#ffffff"
                        }
                    },
                    "val": "sun"
                },
                {
                    "blockStyle": {
                        "minWidth": "15%",
                        "padding": 20,
                        "marginRight": 2,
                        "cursor": "pointer",
                        "background": "rgb(59, 60, 81)"
                    },
                    "icon": {
                        "img": "https://pixsector.com/cache/517d8be6/av5c8336583e291842624.png",
                        "style": {
                            "width": "50px",
                            "height": "auto"
                        }
                    },
                    "title": {
                        "text": "Monday",
                        "style": {
                            "textAlign": "center",
                            "color": "#ffffff"
                        }
                    },
                    "val": "mon"
                },
                {
                    "blockStyle": {
                        "minWidth": "15%",
                        "padding": 20,
                        "marginRight": 2,
                        "cursor": "pointer",
                        "background": "rgb(59, 60, 81)"
                    },
                    "icon": {
                        "img": "https://pixsector.com/cache/517d8be6/av5c8336583e291842624.png",
                        "style": {
                            "width": "50px",
                            "height": "auto"
                        }
                    },
                    "title": {
                        "text": "Tuesday",
                        "style": {
                            "textAlign": "center",
                            "color": "#ffffff"
                        }
                    },
                    "val": "tues"
                },
                {
                    "blockStyle": {
                        "minWidth": "15%",
                        "padding": 20,
                        "marginRight": 2,
                        "cursor": "pointer",
                        "background": "rgb(59, 60, 81)"
                    },
                    "icon": {
                        "img": "https://pixsector.com/cache/517d8be6/av5c8336583e291842624.png",
                        "style": {
                            "width": "50px",
                            "height": "auto"
                        }
                    },
                    "title": {
                        "text": "Wednesday",
                        "style": {
                            "textAlign": "center",
                            "color": "#ffffff"
                        }
                    },
                    "val": "wed"
                },
                {
                    "blockStyle": {
                        "minWidth": "15%",
                        "padding": 20,
                        "marginRight": 2,
                        "cursor": "pointer",
                        "background": "rgb(59, 60, 81)"
                    },
                    "icon": {
                        "img": "https://pixsector.com/cache/517d8be6/av5c8336583e291842624.png",
                        "style": {
                            "width": "50px",
                            "height": "auto"
                        }
                    },
                    "title": {
                        "text": "Thursday",
                        "style": {
                            "textAlign": "center",
                            "color": "#ffffff"
                        }
                    },
                    "val": "thurs"
                },
                {
                    "blockStyle": {
                        "minWidth": "15%",
                        "padding": 20,
                        "marginRight": 2,
                        "cursor": "pointer",
                        "background": "rgb(59, 60, 81)"
                    },
                    "icon": {
                        "img": "https://pixsector.com/cache/517d8be6/av5c8336583e291842624.png",
                        "style": {
                            "width": "50px",
                            "height": "auto"
                        }
                    },
                    "title": {
                        "text": "Friday",
                        "style": {
                            "textAlign": "center",
                            "color": "#ffffff"
                        }
                    },
                    "val": "friday"
                },
                {
                    "blockStyle": {
                        "minWidth": "15%",
                        "padding": 20,
                        "marginRight": 2,
                        "cursor": "pointer",
                        "background": "rgb(59, 60, 81)"
                    },
                    "icon": {
                        "img": "https://pixsector.com/cache/517d8be6/av5c8336583e291842624.png",
                        "style": {
                            "width": "50px",
                            "height": "auto"
                        }
                    },
                    "title": {
                        "text": "Saturday",
                        "style": {
                            "textAlign": "center",
                            "color": "#ffffff"
                        }
                    },
                    "val": "sat"
                }
            ];
            values.default = [];
        }
        elementLists.splice(specificIndx, 0, values);
        saveQuery({ elements: elementLists })
    }

    const editControl = (values, indx) => {
        if (values.typ === 'dropDown') {
            if (values.source === 'mdict') {
                values.sourceParams = {
                    typ: values.sourceParams_mdict,
                    subTyp: 'idame'
                }
            }
            if (values.source === 'cropdown') {
                values.sourceParams = {
                    name: values.sourceParams_cropdown,
                    // subTyp: 'idame'
                }
            }
        }
        let listIndx = indx?.toString() || modalData.data.listIndx
        setSmodalLoading(false);
        let selectedElements = [...selectedControls];
        let index = selectedElements.findIndex((_, i) => i === parseInt(listIndx));
        values = { ...selectedElements[index], ...values };
        selectedElements[index] = values;
        saveQuery({ elements: selectedElements });
    }


    const editFooterBtn = (btn, btnLabel) => {
        let footerBtnElements = [...zenFooterButtons];
        Object.keys(btn).forEach(x => {
            let propVal = btn[x];
            Object.keys(propVal).forEach(y => {
                let val = propVal[y];
                if (val === true) {
                    val = 'true';
                }
                if (val === false) {
                    val = 'false';
                };
                let buttonElement = footerBtnElements.find(btnElem => btnElem.data_index === `${x}-${y}`);
                if (buttonElement) {
                    buttonElement.default = val
                };
                setElementLoading(false);
                setModalElements(footerBtnElements);
                setFooterBtnModal({
                    ...footerBtnModal,
                    typ: 'edit-footer-btn',
                    open: true,
                    data: btnLabel
                });
                console.log(footerBtnElements);
                setTimeout(() => {
                    form.setFieldValue(`${x}-${y}`, val);
                }, 500)
            })
        });
    };


    const deleteFooterBtn = (btn) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this button?',
            okButtonProps: { danger: true },
            okText: 'Yes',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    let footerBtns = { ...pageConfigData.config.footerButtons };
                    footerBtns[btn].buttonProp.visible = false;
                    footerBtns[btn].buttonProp.enable = false;
                    saveQuery({ footerButtons: footerBtns, resolve, reject });
                })
            }
        })
    };

    const deleteControl = (index) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this control?',
            okButtonProps: { danger: true },
            okText: 'Yes',
            onOk: () => {
                let elements = [...selectedControls];
                elements = elements.filter((_, i) => i !== index);
                saveQuery({ elements });
            }
        })
        console.log('in process');
    }

    const onJsonUpload = (values) => {
        setSmodalLoading(true);
        let formData = new FormData();
        formData.append('dictName', pageConfigData?.config?.dictName);
        formData.append('pageconfigId', pageConfigData?.config?.pageconfigId);
        Object.keys(values).forEach(x => {
            formData.append(x, values[x]);
        });
        let dictFormData = dictForm.getFieldsValue();
        Object.keys(dictFormData).forEach(x => {
            formData.append(x, dictFormData[x]);
        });
        liracrypt.uploadFile('/pageconfig/upload', formData)
            .then(({ data }) => {
                console.log(data);
                setSmodalLoading(false);
                if (data.isSuccess) {
                    dictForm.submit();
                    closeModal();
                    //    message.success(data.message || 'Successfully Saved');
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                setSmodalLoading(false);
                console.log(err);
                message.error('Something went wrong');
            })
    }


    return (
        <div>
            <div className='phantom-form'>
                <StAddNew
                    initForm={dictForm}
                    colSpan={12}
                    stopResetForm={true}
                    urlEndpoint="/miscellaneous/pageconfig"
                    urlData={{ dictName: "QueryBuilderQuery" }}
                    extraData={{}}
                    onCallFinish={({ data }) => {
                        setDictFormVal(dictForm.getFieldsValue());
                        smodalForm.resetFields();
                        // dictForm.resetFields();
                        setPageConfigData(null);
                        setSelectedControls(null);
                        setTimeout(() => {
                            setPageConfigData(data);
                            setSelectedControls(data.config.modalElements);
                        }, 500);
                    }}
                />
            </div>
            {
                pageConfigData && (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginBottom: 20 }}>
                            <Button ghost={true} type="primary" style={{ marginRight: 20 }} onClick={() => {
                                openSmodal({ typ: 'add-control' });
                            }}>
                                Add New Control
                            </Button>
                            {
                                dictFormVal.typ1 !== 'PhantomQuery' ?
                                    <Button ghost={true} type="primary" style={{ marginRight: 20 }} onClick={() => openFooterModal({ typ: 'add-footer-btn' })}>
                                        Add Footer Btn
                                    </Button> : <></>
                            }
                            <Button ghost={true} style={{ marginRight: 20 }} type="primary" onClick={downloadJson}>
                                Download JSON
                            </Button>
                            <Button ghost={true} style={{ marginRight: 20 }} type="primary" onClick={() => openSmodal({ typ: 'upload-json' })}>
                                Upload JSON
                            </Button>
                            <Button ghost={true} style={{ marginRight: 20 }} type="primary" onClick={() => window.open(`/v02/${urlCode}/zen-json-editor?dictName=editDropDownQuery`, '_blank')}>
                                Edit Dropdown
                            </Button>
                            <Dropdown trigger={['click']} menu={{
                                items: [
                                    {
                                        label: 'Cropdown',
                                        key: '/sn?op=qy&dictName=CreateNewCropdown',
                                    },
                                    {
                                        label: 'DynamicDropdown',
                                        key: '/sn?op=qy&dictName=CreateNewDynamicDropdown',
                                    },
                                    {
                                        label: 'GilDropdown',
                                        key: '/sn?op=qy&dictName=CreateNewGilDropdown',
                                    },
                                    {
                                        label: 'MultiLevelDropdown',
                                        key: '/sn?op=qy&dictName=CreateNewMultiLevelDropdown',
                                    },
                                    {
                                        label: 'TypSubtypDropdown',
                                        key: '/sn?op=qy&dictName=CreateNewTypSubtypDropdown',
                                    },
                                    {
                                        label: 'TypSubtypDynamicDropdown',
                                        key: '/sn?op=qy&dictName=CreateNewTypSubtypDynamicDropdown',
                                    }
                                ], onClick: ({ key }) => { window.open(`/v02/${urlCode}${key} `, '_blank') }
                            }}>
                                <Button ghost={true} style={{ marginRight: 20 }} type="primary">
                                    New Dropdown
                                </Button>
                            </Dropdown>
                        </div>
                        <div className={`AuditSection CreateAudit`} style={{ padding: "10px" }}>
                            <div className={`ThemeForm phantom-form`}>
                                <Form
                                    name={`ReportForm `}
                                    form={previewForm}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    layout="horizontal"
                                    colon={false}
                                    onFinish={() => { }}
                                    size="large"
                                >
                                    <div
                                        className="settingModal"
                                        style={{
                                            maxHeight: "400px",
                                            overflowY: "scroll",
                                            overflowX: "hidden",
                                        }}
                                    >
                                        {selectedControls?.length &&
                                            selectedControls.map((data, index) => {
                                                return (
                                                    <div key={index} className='zen-preview-control-wrapper'>
                                                        <InputIdentify
                                                            //    layoutPosition={layoutPosition}
                                                            colSpan={12}
                                                            form={previewForm}
                                                            name={data["data_index"]}
                                                            pname={data["p_data_index"]}
                                                            label={data["label"]}
                                                            defaultValue={data["default"]}
                                                            defaultFrom={data["defaultFrom"]}
                                                            defaultTo={data["defaultTo"]}
                                                            typ={data["typ"]}
                                                            disabled={data["readOnly"]}
                                                            source={data["source"]}
                                                            sourceParams={data["sourceParams"]}
                                                            auxParams={data["auxParams"]}
                                                            format={data["format"]}
                                                            errorMessage={data["errorMessage"]}
                                                            placeHolder={data["placeHolder"]}
                                                            required={data["required"]}
                                                            options={data["data"]}
                                                            from={data["data_index_from"]}
                                                            to={data["data_index_to"]}
                                                            url={data["url"]}
                                                            includeAll={data["includeAll"]}
                                                            multiSelect={data["multiSelect"]}
                                                            // searchable={data["isSearchable"]}
                                                            searchable={true}
                                                            data={data}

                                                        />
                                                        <div className='control-edit-btns' style={{ display: 'flex' }}>
                                                            {
                                                                nonEditableControl.includes(data.typ) ?
                                                                    <></> :
                                                                    <Tooltip title="Edit" color="green">
                                                                        <Button
                                                                            style={{ marginRight: 10 }}
                                                                            onClick={() => {
                                                                                openSmodal({ typ: 'edit-control', data: { ...data, zenPreviewListIndex: index } })
                                                                            }}
                                                                            type="link"
                                                                            icon={
                                                                                <EditOutlined style={{ fontSize: 30 }} />
                                                                            }
                                                                        >{''}</Button>
                                                                    </Tooltip>
                                                            }
                                                            <Tooltip title="Edit JSON" color="green">
                                                                <Button
                                                                    style={{ marginRight: 10 }}
                                                                    onClick={() => {
                                                                        openJSONModal({
                                                                            ...data,
                                                                            dictName: `ZenFormBuilder_${data.typ}`,
                                                                            zenPreviewListIndex: index
                                                                        })
                                                                    }}
                                                                    type="link"
                                                                    icon={
                                                                        <CodeOutlined style={{ fontSize: 30 }} />
                                                                    }
                                                                >{''}</Button>
                                                            </Tooltip>

                                                            <Tooltip title="Delete" color="red">
                                                                <Button
                                                                    style={{ marginLeft: 10, marginRight: 10 }}
                                                                    onClick={() => {
                                                                        deleteControl(index)
                                                                    }}
                                                                    type="link"
                                                                    danger={true}
                                                                    icon={
                                                                        <DeleteOutlined style={{ fontSize: 30 }} />
                                                                    }
                                                                >{''}</Button>
                                                            </Tooltip>
                                                            {/* <Tooltip title={data.visible ? 'Completed' : 'Incomplete'} color={data.visible ? 'green' : 'red'}>
                                                <div className='circle' style={{ height: 20, width: 20, background: data.visible ? 'green' : 'red', marginRight: 10, marginTop: 10 }}></div>
                                            </Tooltip> */}
                                                            <p style={{ color: '#52c41a', marginBottom: 0, marginTop: 10, fontSize: 15 }}>{`[${index}]`}</p>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                    {
                                        pageConfigData?.config.footerButtons && (
                                            <Row style={{ width: '100%' }} gutter={24} justify="center">
                                                <Col span={24} style={{ display: 'inline-flex', justifyContent: 'center' }}>
                                                    {Object.keys(pageConfigData?.config.footerButtons).map((btn, idx) => {
                                                        const button = pageConfigData?.config.footerButtons[btn];
                                                        if (button?.buttonProp?.visible) {
                                                            return (
                                                                <div className={`zen-preview-control-wrapper ${button?.buttonProp?.visible ? 'visible-control' : 'invisible-control'}`} key={idx}>
                                                                    <FooterButtons
                                                                        postSubmitAction={() => { }}
                                                                        openPopupModal={() => { }}
                                                                        button={button}
                                                                        setSelectedButton={() => { }}
                                                                        form={previewForm}
                                                                        label={button?.buttonProp?.label}
                                                                        type={button?.buttonProp?.type}
                                                                        disabled={!button?.buttonProp?.enable}
                                                                        confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                                                                        submitFormData={button?.submitFormDataProp}
                                                                    />
                                                                    <div className='control-edit-btns footer' style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <Tooltip title="Edit" color="green">
                                                                            <Button
                                                                                style={{ marginRight: 10, color: 'green' }}
                                                                                onClick={() => editFooterBtn(button, btn)}
                                                                                type="link"
                                                                                icon={
                                                                                    <EditOutlined style={{ fontSize: 30 }} />
                                                                                }
                                                                            >{''}</Button>
                                                                        </Tooltip>

                                                                        <Tooltip title="Delete" color="red">
                                                                            <Button
                                                                                style={{ marginLeft: 10 }}
                                                                                onClick={() => {
                                                                                    deleteFooterBtn(btn)
                                                                                }}
                                                                                type="link"
                                                                                danger={true}
                                                                                icon={
                                                                                    <DeleteOutlined style={{ fontSize: 30 }} />
                                                                                }
                                                                            >{''}</Button>
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>

                                                            )
                                                        }
                                                    })}
                                                </Col>
                                            </Row>
                                        )
                                    }
                                    {/* <Row gutter={24} justify="center">
                            <Col span={24}>
                                {
                                    button === 'default' ?
                                        <Button
                                            form={form}
                                            // marginLeft={btnMargin ? btnMargin : "320px"}
                                            loading={loading}
                                            cancelButtonText={"Reset"}
                                            submitButtonText={"Submit"}
                                            resetButton={true}
                                        /> :
                                        <Button width={"100%"} submitButtonText="Search" form={form} loading={loading} />
                                }
                            </Col>
                        </Row> */}
                                </Form>
                            </div>
                        </div>
                    </>
                )
            }

            <Modal maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={modalData.open} title={modalTitle || "Add Zen Form Control"} onCancel={closeModal}>
                {
                    (!elementLoading && modalData.open) && (
                        <>
                            <StAddNew
                                dropdownExtraData={{ dictName: pageConfigData?.config?.dictName, ...dictForm.getFieldsValue() }}
                                urlMethod={modalData.typ !== 'upload-json' ? "POST" : undefined}
                                formName="EditQueryForm"
                                setSmodalTitle={title => { setModalTitle(title) }}
                                initForm={smodalForm}
                                colSpan={24}
                                urlEndpoint={modalData.typ === 'upload-json' ? '/smodal' : '/smodal/zenform'}
                                urlData={modalData.typ === 'upload-json' ? {
                                    dictName: 'ZenFormBuilder_jsonUploader',
                                    pageConfigId: pageConfigData?.config?.pageconfigId,
                                    selectedDictName: pageConfigData?.config?.dictName,
                                } : {
                                    ...modalData.data,
                                    dictName: modalData.typ === 'add-control' ?
                                        `QueryElementBuilder_addNew` :
                                        modalData.typ === 'edit-control' ?
                                            `ZenFormBuilder_${modalData.data.typ}` : ''
                                }}
                                // dictName={currentStep?.smodal?.dictName}
                                //  pageName={currentStep?.smodal?.pageName}
                                onFormSubmit={modalData.typ === 'add-control' ?
                                    addControl :
                                    modalData.typ === 'edit-control' ?
                                        (values) => { editControl(values, modalData.data.zenPreviewListIndex) } :
                                        onJsonUpload
                                }
                            />
                            <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                                <Button loading={smodalLoading} htmlType='submit' type="primary" form={'EditQueryForm'}>Submit</Button>
                            </div>
                        </>
                    )
                }
            </Modal>
            <Modal width={'50%'} style={{ width: '70%' }} maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={jsonModalData.open} title="Edit Control JSON" onCancel={closeJSONModal}>
                {
                    elementLoading ?
                        <></> :
                        Object.keys(controlJsonData).length ? (
                            <JsonEditor
                                width={650}
                                data={controlJsonData}
                                onChange={(data) => {
                                    setControlJsonData(data)
                                }}
                                optionsMap={{
                                    color: [
                                        { value: 'red', label: 'Red' },
                                        { value: 'blue', label: 'Blue' },
                                    ],
                                    city: [
                                        { value: 'beijing', label: 'Beijing' },
                                        { value: 'shanghai', label: 'Shanghai' },
                                    ],
                                }}
                            />
                        ) : <></>
                }
                <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                    <Button loading={smodalLoading} onClick={() => editControl(controlJsonData, jsonModalData.data.zenPreviewListIndex)} type="primary" form={'EditZenFormControl'}>Submit</Button>
                </div>
            </Modal>

            <Modal maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={footerBtnModal.open} title={"Add Footer Button"} onCancel={closeFooterBtnModal}>
                {
                    (!elementLoading && footerBtnModal.open) && (
                        <div className={'customer-complaint'} style={{ padding: "10px" }}>
                            <div className="customer-form">
                                <Form
                                    name={`ReportForm `}
                                    labelWrap={true}
                                    form={form}
                                    labelCol={{ span: 8 }}
                                    layout={"horizontal"}
                                    colon={false}
                                    onFinish={saveFooterBtn}
                                    size="large"
                                >
                                    <Row>
                                        {
                                            modalElements.map((data, index) => {
                                                // if (dtArray.includes(data["typ"])) {

                                                //     LocalDict[data["data_index"]] = data["format"]
                                                //         ? data["format"]
                                                //         : "YYYY-MM-DD hh:mm:ss";
                                                //     LocalDict["data_index_from"] = data["data_index_from"];
                                                //     LocalDict["data_index_to"] = data["data_index_to"];
                                                // }
                                                if (data.visible) {
                                                    return (
                                                        <ZenFormInput
                                                            childType={data.childType}
                                                            header={data.header}
                                                            footer={data.footer}
                                                            labelColSpan={data["labelColSpan"]}
                                                            style={data['style']}
                                                            height={data['height']}
                                                            layoutPosition="space-between"
                                                            form={form}
                                                            rows={data.rows}
                                                            colSpan={24}
                                                            name={data["data_index"]}
                                                            label={data["label"]}
                                                            defaultValue={data["default"]}
                                                            typ={data["typ"]}
                                                            disabled={data["readOnly"]}
                                                            source={data["source"]}
                                                            sourceParams={data["sourceParams"]}
                                                            auxParams={data["auxParams"]}
                                                            format={data["format"]}
                                                            errorMessage={data["errorMessage"]}
                                                            placeHolder={data["placeHolder"]}
                                                            required={data["required"]}
                                                            options={data["data"]}
                                                            from={data["data_index_from"]}
                                                            to={data["data_index_to"]}
                                                            url={data["url"]}
                                                            includeAll={data["includeAll"]}
                                                            pname={data["p_data_index"]}
                                                            defaultFrom={data["defaultFrom"]}
                                                            defaultTo={data["defaultTo"]}
                                                            multiSelect={data["multiSelect"]}
                                                            searchable={data["isSearchable"]}
                                                            data={data}
                                                            //   extraData={extraData}
                                                            children={data['children']}
                                                        />
                                                    );
                                                }
                                            })}
                                    </Row>
                                    <Row gutter={24} justify="center">
                                        <Col span={4}>
                                            {
                                                <Button htmlType='submit' type="primary">Submit</Button>
                                            }
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    )
                }
            </Modal>
        </div>
    )
}

export default QueryBuilder;